import { StyledListImage } from "../../style";
import { StyledInfoWrapper, StyledLoadListInfo } from "../style";
import {
    SL_LOAD_LIST_INFO_TEXT_POINT_1,
    SL_LOAD_LIST_INFO_TEXT_POINT_2,
} from "../../../translations/suppressionListKeys";
import { AssetsService } from "app/services/AssetsService";
import { SL_IMG_LISTS } from "app/pages/sales-intelligence/pages/management/constants/constants";
import { StyledList } from "app/pages/sales-intelligence/pages/management/components/Management/styles";
import { translate } from "app/filters/i18nFilter";

export const UploadInstructions = () => {
    return (
        <StyledInfoWrapper>
            <StyledListImage
                src={AssetsService.assetUrl(SL_IMG_LISTS)}
                alt="suppression-list-img"
            />
            <StyledLoadListInfo>
                <StyledList
                    style={{
                        padding: 0,
                        listStylePosition: "outside",
                        margin: "0 0 0 25px",
                    }}
                >
                    <li>{translate(SL_LOAD_LIST_INFO_TEXT_POINT_1)}</li>
                    <li style={{ marginTop: "15px" }}>{translate(SL_LOAD_LIST_INFO_TEXT_POINT_2)}</li>
                </StyledList>
            </StyledLoadListInfo>
        </StyledInfoWrapper>
    );
};
